export enum RelatedObjectType {
    Individual = 1,
    Entity = 2,
    Mandate = 3
}
